import React from "react";
import { Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import FiltersBar from "./FiltersBar";
import type { DateMode } from "../types";

type ControlStockFiltersDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  serverOptions: string[];
  serverFilter: string;
  onServerFilterChange: (value: string) => void;
  branchOptions: string[];
  branchFilter: string[];
  onBranchFilterChange: (value: string[]) => void;
  controlMode: "recetas" | "inventario";
  onControlModeChange: (value: "recetas" | "inventario") => void;
  differenceFilter: "todas" | "con" | "sin" | "positivas" | "negativas";
  onDifferenceFilterChange: (
    value: "todas" | "con" | "sin" | "positivas" | "negativas",
  ) => void;
  metricMode: "cantidad" | "monto" | "ambos";
  onMetricModeChange: (value: "cantidad" | "monto" | "ambos") => void;
  dateModeDropdownOpen: boolean;
  toggleDateModeDropdown: () => void;
  currentModeOption: { label: string; icon: string };
  dateSelectionMode: DateMode;
  onModeChange: (mode: DateMode) => void;
  renderDateModeInput: () => React.ReactNode;
};

const ControlStockFiltersDrawer = ({
  isOpen,
  onClose,
  serverOptions,
  serverFilter,
  onServerFilterChange,
  branchOptions,
  branchFilter,
  onBranchFilterChange,
  controlMode,
  onControlModeChange,
  differenceFilter,
  onDifferenceFilterChange,
  metricMode,
  onMetricModeChange,
  dateModeDropdownOpen,
  toggleDateModeDropdown,
  currentModeOption,
  dateSelectionMode,
  onModeChange,
  renderDateModeInput,
}: ControlStockFiltersDrawerProps) => {
  return (
    <Offcanvas direction="end" isOpen={isOpen} toggle={onClose} scrollable>
      <OffcanvasHeader toggle={onClose}>Filtros</OffcanvasHeader>
      <OffcanvasBody>
        <FiltersBar
          serverOptions={serverOptions}
          serverFilter={serverFilter}
          onServerFilterChange={onServerFilterChange}
          branchOptions={branchOptions}
          branchFilter={branchFilter}
          onBranchFilterChange={onBranchFilterChange}
          controlMode={controlMode}
          onControlModeChange={onControlModeChange}
          differenceFilter={differenceFilter}
          onDifferenceFilterChange={onDifferenceFilterChange}
          metricMode={metricMode}
          onMetricModeChange={onMetricModeChange}
          dateModeDropdownOpen={dateModeDropdownOpen}
          toggleDateModeDropdown={toggleDateModeDropdown}
          currentModeOption={currentModeOption}
          dateSelectionMode={dateSelectionMode}
          onModeChange={onModeChange}
          renderDateModeInput={renderDateModeInput}
        />
      </OffcanvasBody>
    </Offcanvas>
  );
};

export default ControlStockFiltersDrawer;
